// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateLaborRateChangesListFilterBy = filterBy => ({
    payload: filterBy,
    property: 'filterBy',
    type: actions.UPDATE_TCSM_LABOR_RATE_FILTER_BY
});

export const updateLaborRateChangesListSortBy = sortBy => ({
    payload: sortBy,
    property: 'sortBy',
    type: actions.UPDATE_TCSM_LABOR_RATE_SORT_BY
});

export const updateLaborRateChangesListSortDirection = sortDirection => ({
    payload: sortDirection,
    property: 'sortDirection',
    type: actions.UPDATE_TCSM_LABOR_RATE_SORT_DIRECTION
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/labor-rate-changes-search-filters.js